// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* comp cards styling */

.FormStyles_input__Ij\\+3A {
  margin: 2rem auto;
  padding: 1rem;
  width: 100%;
  color: var(--text-light);
  font-size: 22px;
  transform: translateY(0%);
  opacity: 1;
}

.FormStyles_expanded__QFBtJ {
  transform: translateY(-20%);
  transition: transform 0.5s ease-in-out;
  opacity: 0.5;
}

@media (max-width: 375px) {
  .FormStyles_input__Ij\\+3A {
    padding-left: 1.2rem;
    overflow-y: auto;
  }
}

.FormStyles_formHeader__ESjYm {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.FormStyles_formKey__MvMRI {
  margin: 0;
  margin-right: 1rem;
  font-family: 'hunter-regular', sans-serif;
  font-size: 30px;
}

.FormStyles_closeButton__dxCDP {
  width: 40px;
  text-align: center;
  font-weight: 700;
  border: 1px solid var(--item-hover);
  border-radius: 8px;
  margin-left: auto;
}

.FormStyles_closeButton__dxCDP:hover {
  border-color: var(--text-light);
  color: var(--item-hover);
}

.FormStyles_input__Ij\\+3A label {
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: var(--text-light);
  font-size: 16px;
}

.FormStyles_input__Ij\\+3A input {
  color: var(--primary);
  font-size: 14px;
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  padding: 0.1rem;
  margin-bottom: 0.5rem;
}

.FormStyles_input__Ij\\+3A input:focus {
  outline: none;
  border-color: var(--item-hover);
}

.FormStyles_p__vyPkW {
  font-size: 14px;
  color: var(--item-bold);
  margin-bottom: 1rem;
}

/* subscribe form styling */

.FormStyles_formId__mDbMk {
  font-family: 'hunter-regular', sans-serif;
}

.FormStyles_formId__mDbMk,
.FormStyles_formTitle__3T\\+IH {
  color: var(--primary);
  margin-left: 1rem;
}

.FormStyles_closeSubscribeButton__REYqQ {
  width: 40px;
  text-align: center;
  font-weight: 700;
  border: 2px solid var(--item-hover);
  border-radius: 8px;
  margin-left: auto;
  margin-right: 0.5rem;
  color: var(--primary);
}

.FormStyles_closeSubscribeButton__REYqQ:hover {
  border-color: var(--primary);
  color: var(--item-hover);
}

.FormStyles_subscribeLabel__eockX {
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: var(--primary);
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/forms/FormStyles.module.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE;IACE,oBAAoB;IACpB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2BAA2B;;AAE3B;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["/* comp cards styling */\n\n.input {\n  margin: 2rem auto;\n  padding: 1rem;\n  width: 100%;\n  color: var(--text-light);\n  font-size: 22px;\n  transform: translateY(0%);\n  opacity: 1;\n}\n\n.expanded {\n  transform: translateY(-20%);\n  transition: transform 0.5s ease-in-out;\n  opacity: 0.5;\n}\n\n@media (max-width: 375px) {\n  .input {\n    padding-left: 1.2rem;\n    overflow-y: auto;\n  }\n}\n\n.formHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.formKey {\n  margin: 0;\n  margin-right: 1rem;\n  font-family: 'hunter-regular', sans-serif;\n  font-size: 30px;\n}\n\n.closeButton {\n  width: 40px;\n  text-align: center;\n  font-weight: 700;\n  border: 1px solid var(--item-hover);\n  border-radius: 8px;\n  margin-left: auto;\n}\n\n.closeButton:hover {\n  border-color: var(--text-light);\n  color: var(--item-hover);\n}\n\n.input label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  color: var(--text-light);\n  font-size: 16px;\n}\n\n.input input {\n  color: var(--primary);\n  font-size: 14px;\n  display: block;\n  width: 100%;\n  border: 1px solid #ccc;\n  padding: 0.1rem;\n  margin-bottom: 0.5rem;\n}\n\n.input input:focus {\n  outline: none;\n  border-color: var(--item-hover);\n}\n\n.p {\n  font-size: 14px;\n  color: var(--item-bold);\n  margin-bottom: 1rem;\n}\n\n/* subscribe form styling */\n\n.formId {\n  font-family: 'hunter-regular', sans-serif;\n}\n\n.formId,\n.formTitle {\n  color: var(--primary);\n  margin-left: 1rem;\n}\n\n.closeSubscribeButton {\n  width: 40px;\n  text-align: center;\n  font-weight: 700;\n  border: 2px solid var(--item-hover);\n  border-radius: 8px;\n  margin-left: auto;\n  margin-right: 0.5rem;\n  color: var(--primary);\n}\n\n.closeSubscribeButton:hover {\n  border-color: var(--primary);\n  color: var(--item-hover);\n}\n\n.subscribeLabel {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  color: var(--primary);\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `FormStyles_input__Ij+3A`,
	"expanded": `FormStyles_expanded__QFBtJ`,
	"formHeader": `FormStyles_formHeader__ESjYm`,
	"formKey": `FormStyles_formKey__MvMRI`,
	"closeButton": `FormStyles_closeButton__dxCDP`,
	"p": `FormStyles_p__vyPkW`,
	"formId": `FormStyles_formId__mDbMk`,
	"formTitle": `FormStyles_formTitle__3T+IH`,
	"closeSubscribeButton": `FormStyles_closeSubscribeButton__REYqQ`,
	"subscribeLabel": `FormStyles_subscribeLabel__eockX`
};
export default ___CSS_LOADER_EXPORT___;
